import { type TFunction } from "i18next";
import { z } from "zod";

export const DRAWER_TEXT_MAX_CHARS = 1000;

export const normalizeDrawerText = (value: string) => value.trim();

const DRAWER_TEXT_ALLOWED_CHARS_REGEX = /^[A-Za-z0-9.,:;!?()_@#%&*' \r\n-]*$/;

export const isDrawerTextAllowed = (value: string) => DRAWER_TEXT_ALLOWED_CHARS_REGEX.test(value);

export const getDrawerTextAllowedCharactersMessage = (t: TFunction) =>
  t("form-validation.drawer-text-allowed-characters");

const drawerText = (t: TFunction, label: string) =>
  z
    .string()
    .trim()
    .max(
      DRAWER_TEXT_MAX_CHARS,
      t("form-validation.max-length", { label, max: DRAWER_TEXT_MAX_CHARS }),
    )
    .regex(DRAWER_TEXT_ALLOWED_CHARS_REGEX, {
      message: getDrawerTextAllowedCharactersMessage(t),
    });

export const getDrawerSchema = (t: TFunction) =>
  z.object({
    description: drawerText(t, t("form-validation.field")).optional(),
    additionalDescription: drawerText(t, t("form-validation.field")).optional(),
    mandatoryDescription: drawerText(t, t("form-validation.resubmission-reason")).min(
      1,
      t("form-validation.required", { label: t("form-validation.resubmission-reason") }),
    ),
    files: z.any().optional(),
    selectedOption: z
      .string()
      .min(1, t("form-validation.required", { label: t("form-validation.field") })),
  });

export type DrawerSchema = z.infer<ReturnType<typeof getDrawerSchema>>;
